/**
 * yake-currency.js — Yake Mall döviz GÖRÜNTÜ çeviricisi (TL / USD / EUR / GBP).
 *
 * Mağaza yalnızca TRY ile satar; bu script fiyatları görüntüde çevirir, ödeme yine TL'dir.
 * Mağazanın para formatı (Ayarlar → Para birimi biçimi) fiyatları <span class="glc-money"> ile sarar;
 * bu script yalnızca .glc-money öğelerini dönüştürür ve TL'ye dönünce orijinal HTML'i geri yükler.
 *
 * Kur kaynağı (sırayla): Frankfurter (ECB) → open.er-api.com → tema ayarındaki elle kurlar.
 * Ayarlar <script data-yake-currency-config> içinden gelir (yake-localization.liquid).
 * window.YakeCurrency: { current(), set(code), tlPerUnit(code), rates(), convert(tl, code), format(amount, code) }
 */
(function () {
  'use strict';
  if (window.YakeCurrency) return;

  var CODES = ['TL', 'USD', 'EUR', 'GBP'];
  var STORAGE_SEL = 'yake_currency';
  var STORAGE_RATES = 'yake_rates_v1';
  var cfgEl = document.querySelector('[data-yake-currency-config]');
  var cfg = { enabled: true, cacheHours: 6, markup: 0, fallback: { USD: 0, EUR: 0, GBP: 0 }, locale: 'tr' };
  try { if (cfgEl) cfg = Object.assign(cfg, JSON.parse(cfgEl.textContent || '{}')); } catch (e) {}
  if (cfg.enabled === false) return;

  var rates = null;         // { USD: tlPerUnit, EUR, GBP }, kaynak
  var current = 'TL';
  var observer = null;
  var pending = false;

  function readStorage(k) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
  function writeStorage(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  function tlPerUnit(code) {
    if (code === 'TL' || code === 'TRY') return 1;
    var r = rates && rates[code];
    if (r && r > 0) return r;
    var f = cfg.fallback && parseFloat(cfg.fallback[code]);
    return f > 0 ? f : 0;
  }
  function markupFactor() { var m = parseFloat(cfg.markup); return isFinite(m) ? 1 + m / 100 : 1; }
  function convert(tl, code) {
    var per = tlPerUnit(code);
    if (!per) return null;
    return (tl / per) * markupFactor();
  }
  function format(amount, code) {
    if (code === 'TL' || code === 'TRY') {
      try { return amount.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + 'TL'; } catch (e) { return amount.toFixed(2) + 'TL'; }
    }
    var loc = code === 'USD' ? 'en-US' : code === 'GBP' ? 'en-GB' : 'de-DE';
    try { return new Intl.NumberFormat(loc, { style: 'currency', currency: code, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount); }
    catch (e) { var sym = code === 'USD' ? '$' : code === 'EUR' ? '€' : '£'; return sym + amount.toFixed(2); }
  }

  // "1,234.56TL" / "1.234,56" / "12.90TL" → 1234.56 (mağaza formatı {{amount}} = 1,234.56)
  function parseTl(text) {
    var m = String(text || '').replace(/\s/g, '').match(/-?\d[\d.,]*/);
    if (!m) return NaN;
    var s = m[0];
    var lastComma = s.lastIndexOf(','), lastDot = s.lastIndexOf('.');
    if (lastComma > -1 && lastDot > -1) {
      if (lastComma > lastDot) s = s.replace(/\./g, '').replace(',', '.');
      else s = s.replace(/,/g, '');
    } else if (lastComma > -1) {
      var dec = s.length - lastComma - 1;
      s = dec === 2 ? s.replace(',', '.') : s.replace(/,/g, '');
    } else if (lastDot > -1) {
      var dec2 = s.length - lastDot - 1;
      if (dec2 === 3 && s.indexOf('.') !== lastDot) s = s.replace(/\./g, '');
      else if (dec2 === 3) s = s.replace(/\./g, '');
    }
    return parseFloat(s);
  }

  function prepare(el) {
    if (el.dataset.yakeTl) return true;
    if (el.closest && el.closest('[data-yake-no-convert]')) return false;
    var v = el.dataset.originalPriceTl != null ? parseFloat(el.dataset.originalPriceTl) : parseTl(el.textContent);
    if (isNaN(v)) return false;
    el.dataset.yakeTl = String(v);
    el.dataset.yakeHtml = el.innerHTML;
    return true;
  }
  function render(el) {
    if (!prepare(el)) return;
    if (current === 'TL') {
      if (el.dataset.yakeConverted === '1') { el.innerHTML = el.dataset.yakeHtml; el.dataset.yakeConverted = '0'; }
      return;
    }
    var out = convert(parseFloat(el.dataset.yakeTl), current);
    if (out == null) return;
    el.textContent = format(out, current);
    el.dataset.yakeConverted = '1';
  }
  function renderAll(root) {
    var nodes = (root || document).querySelectorAll('.glc-money');
    for (var i = 0; i < nodes.length; i++) render(nodes[i]);
    if (root && root.matches && root.matches('.glc-money')) render(root);
  }
  function scheduleRender() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; renderAll(); });
  }

  function updateUi() {
    document.querySelectorAll('[data-yake-currency-current]').forEach(function (el) { el.textContent = current; });
    document.querySelectorAll('[data-yake-currency-option]').forEach(function (b) {
      var on = b.getAttribute('data-yake-currency-option') === current;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-current', on ? 'true' : 'false');
    });
    document.documentElement.setAttribute('data-yake-currency', current);
  }

  function setCurrency(code, silent, manual) {
    if (CODES.indexOf(code) < 0) code = 'TL';
    if (code !== 'TL' && !tlPerUnit(code)) { code = 'TL'; }
    current = code;
    // manual: ziyaretçi seçiciden kendisi seçti → dil değişse de korunur
    writeStorage(STORAGE_SEL, { code: code, ts: Date.now(), manual: !!manual });
    updateUi();
    renderAll();
    if (!silent) document.dispatchEvent(new CustomEvent('yake:currency', { detail: { code: code, tlPerUnit: tlPerUnit(code) } }));
  }

  // ---- kur kaynakları ----
  function fetchJson(url) {
    return fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  function fromFrankfurter() {
    return fetchJson('https://api.frankfurter.app/latest?from=TRY&to=USD,EUR,GBP').then(function (d) {
      var out = {};
      ['USD', 'EUR', 'GBP'].forEach(function (c) { var r = d && d.rates && d.rates[c]; if (r > 0) out[c] = 1 / r; });
      if (!out.USD) throw new Error('frankfurter boş');
      return { rates: out, src: 'frankfurter', date: d.date };
    });
  }
  function fromErApi() {
    return fetchJson('https://open.er-api.com/v6/latest/TRY').then(function (d) {
      var out = {};
      ['USD', 'EUR', 'GBP'].forEach(function (c) { var r = d && d.rates && d.rates[c]; if (r > 0) out[c] = 1 / r; });
      if (!out.USD) throw new Error('er-api boş');
      return { rates: out, src: 'er-api', date: d.time_last_update_utc };
    });
  }
  function loadRates() {
    var cached = readStorage(STORAGE_RATES);
    var ttl = Math.max(1, parseFloat(cfg.cacheHours) || 6) * 3600 * 1000;
    if (cached && cached.rates && Date.now() - cached.ts < ttl) {
      rates = cached.rates; rates._src = cached.src;
      return Promise.resolve(rates);
    }
    return fromFrankfurter().catch(fromErApi).then(function (res) {
      rates = res.rates; rates._src = res.src;
      writeStorage(STORAGE_RATES, { ts: Date.now(), rates: res.rates, src: res.src, date: res.date });
      return rates;
    }).catch(function (e) {
      if (cached && cached.rates) { rates = cached.rates; rates._src = 'cache'; return rates; }
      rates = null;
      return null;
    });
  }

  // ---- UI bağlama ----
  function bindUi() {
    document.addEventListener('click', function (e) {
      var opt = e.target && e.target.closest ? e.target.closest('[data-yake-currency-option]') : null;
      if (opt) {
        e.preventDefault();
        setCurrency(opt.getAttribute('data-yake-currency-option'), false, true);
        var dd = opt.closest('details'); if (dd) dd.removeAttribute('open');
        return;
      }
      // dışarı tıklayınca açık menüleri kapat
      document.querySelectorAll('details.yake-loc__dd[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') document.querySelectorAll('details.yake-loc__dd[open]').forEach(function (d) { d.removeAttribute('open'); }); });
  }

  // Dil → varsayılan para birimi (seçicide kapalı olan birim seçilmez, TL'ye düşer)
  function languageCurrency(locale) {
    var lang = String(locale || '').slice(0, 2).toLowerCase();
    var code = lang === 'tr' ? 'TL' : ['de', 'fr', 'it', 'es', 'nl', 'pt'].indexOf(lang) >= 0 ? 'EUR' : 'USD';
    var avail = cfg.available || CODES;
    if (avail.indexOf(code) < 0) code = code === 'EUR' && avail.indexOf('USD') >= 0 ? 'USD' : 'TL';
    return code;
  }
  function init() {
    bindUi();
    var saved = readStorage(STORAGE_SEL);
    var savedOk = saved && saved.code && CODES.indexOf(saved.code) >= 0;
    // Eski kayıtlarda "manual" yok; TL dışı bir seçim ancak elle yapılmış olabilir
    var isManual = savedOk && (saved.manual === true || (saved.manual === undefined && saved.code !== 'TL'));
    var want = savedOk ? saved.code : 'TL';
    if (!isManual && cfg.autoByLanguage) want = languageCurrency(cfg.locale);
    if (window.MutationObserver) {
      observer = new MutationObserver(function (muts) {
        if (current === 'TL') return;
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { scheduleRender(); return; }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
    loadRates().then(function () { setCurrency(want, true, isManual); document.dispatchEvent(new CustomEvent('yake:currency-ready', { detail: { rates: rates } })); });
    updateUi();
  }

  window.YakeCurrency = {
    current: function () { return current; },
    set: setCurrency,
    tlPerUnit: tlPerUnit,
    rates: function () { return rates; },
    convert: convert,
    format: format,
    refresh: renderAll,
    ready: loadRates,
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
